let VueAuthPlugin = {}

VueAuthPlugin.install = (Vue, store) => {
  Vue.prototype.can = authCode => {
    return store.state.app.permittedAuthorizations === undefined || store.state.app.permittedAuthorizations.indexOf(authCode) >= 0
  }
  Vue.prototype.canLink = authCode => {
    let hasAuthorization = store.state.app.permittedAuthorizations === undefined || store.state.app.permittedAuthorizations.indexOf(authCode) >= 0
    if (hasAuthorization) {
      return ''
    }
    return 'link-disabled'
  }
}

export default VueAuthPlugin
